<div *ngIf="!editState, else editingData">

  <button mat-icon-button (click)="onBackToList()">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <button mat-icon-button (click)="onChangeEditState()">
    <mat-icon>mode_edit</mat-icon>
  </button>

 <!-- <button mat-icon-button [matMenuTriggerFor]="optMenu">
    <mat-icon>more_vert</mat-icon>
  </button>
   <mat-menu #optMenu="matMenu">
    <button mat-menu-item>Excluir</button>
  </mat-menu> -->

</div>

<ng-template #editingData>

  <button mat-icon-button (click)="onBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <button mat-icon-button (click)="onChangeEditState()">
    <mat-icon>check</mat-icon>
  </button>

  <!--<button mat-icon-button [matMenuTriggerFor]="optMenu">
    <mat-icon>more_vert</mat-icon>
  </button>
   <mat-menu #optMenu="matMenu">
    <button mat-menu-item>Excluir</button>
  </mat-menu> -->

</ng-template>
